<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Ayuda</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice/home" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-list>
    <ion-item button (click)="goHelp('service')" lines="none">
      <ion-label>Servicio al cliente</ion-label>
      <ion-icon slot="start" class="icono" src="assets/icon/services.svg"></ion-icon>
    </ion-item>
    <ion-item button (click)="goHelp('products')" lines="none">
      <ion-label>Productos</ion-label>
      <ion-icon slot="start" class="icono" src="assets/icon/products.svg"></ion-icon>
    </ion-item>
    <ion-item button (click)="goHelp('invoice')" lines="none">
      <ion-label>Facturación</ion-label>
      <ion-icon slot="start" class="icono" src="assets/icon/invoice.svg"></ion-icon>
    </ion-item>
    <ion-item button (click)="goHelp('other')" lines="none">
      <ion-label>Otro</ion-label>
      <ion-icon slot="start" class="icono" src="assets/icon/others.svg"></ion-icon>
    </ion-item>
  </ion-list>
</ion-content>
